import { InsertSnippetModal } from 'modules/snippets/components/modals/InsertSnippetModal';
import { FC, PropsWithChildren } from 'react';
import { useModalContext } from 'utils/contexts/modal';
import { useInsertAtCursor } from '../../hooks/useInsertAtCursor';
import { Modals } from '../../types';
import { SnippetSelectorContext } from './SnippetSelectorContext';

export const SnippetSelectorProvider: FC<PropsWithChildren<unknown>> = ({ children }) => {
  const { showModal, modalState, hideModal } = useModalContext<Modals>();

  const handleSnippetInsert = useInsertAtCursor();

  const showSnippetSelector = () => {
    showModal(Modals.SnippetSelector);
  };

  return (
    <SnippetSelectorContext.Provider value={{ showSnippetSelector }}>
      {modalState === Modals.SnippetSelector && (
        <InsertSnippetModal closeModal={hideModal} onInsertSnippet={handleSnippetInsert} />
      )}
      {children}
    </SnippetSelectorContext.Provider>
  );
};
